<template>
    <!-- 报表管理－票券核销汇总 -->
    <div>
        <content-view v-show="$utils.renderWhen(this,'ticketVerStatistics')">
            <div slot="header">
                <a-form :form="form" layout="inline" class="store-one-form">
                    <a-form-item label="日期">
                        <a-range-picker
                            style="width:282px"
                            format="YYYY/MM/DD"
                            v-decorator="['startTime',{initialValue: [$moment(),$moment()]}]"
                            @change="onChangeDate"
                        />
                    </a-form-item>
                    <a-form-item class="wrap-header-button">
                        <a-button @click="getList" class="mr8" type="primary">筛选</a-button>
                        <a-button @click="handleReset">重置</a-button>
                    </a-form-item>
                </a-form>
            </div>

            <a-card :border="false">
                <a-alert slot="title" :message="message" class="mr40"></a-alert>
                <template slot="extra" v-if="getBtnByAuth('exportTicketVerStatistics')">
                    <a-button type="primary" @click="exportExcel" :loading="loading">导出excel</a-button>
                    <a-button @click="openExportModal">导出记录</a-button>
                </template>
                <a-table
                    :bordered="true"
                    :dataSource="dataSource"
                    :columns="columns"
                    :pagination="false"
                    :rowKey="(record,index) => index"
                >
                </a-table>
            </a-card>
            <report-export-modal ref="reportExportModal" :exportType="38"></report-export-modal>
        </content-view>
        <router-view></router-view>
    </div>
</template>

<script type="text/javascript">
    import { mapGetters } from "vuex"
    const columns = [
        {
            title: "票券内部标识",
            dataIndex: "ticketName"
        },
        {
            title: "票券展示名称",
            dataIndex: "ticketShowName"
        },
        {
            title: "核销张数（张）",
            dataIndex: "count"
        },
    ];
    export default {
        name: "ticketVerStatistics",
        components: {},
        props: {},
        data() {
            return {
                dataSource: [],
                columns,
                message: '总核销人数：0人，其中成人0人、儿童0人',
                loading: false,
            };
        },
        watch: {
            $route: function(newVal, oldVal) {
                if (newVal.name === "ticketVerStatistics") {
                    this.getList();
                }
            },
            shopId() {
                this.getList();
            }
        },
        methods: {
            onChangeDate() {
                setTimeout(() => {
                    this.getList()
                },100)
            },
            //重置
            handleReset() {
                this.form.resetFields();
                this.getList()
            },
            //获取列表 
            getList() {
                if(!this.shopId) return
                this.form.validateFields((err, values) => {
                    if (err) return;
                    const startTime = values['startTime'] ? values['startTime'] : []
                    values.startDate = startTime.length > 0 ? startTime[0].format('YYYY-MM-DD') : undefined
                    values.endDate = startTime.length > 0 ? startTime[1].format('YYYY-MM-DD') : undefined
                    this.$api.statement.ticketVerifyCountDay({
                        body: {
                            ...values,
                            shopId: this.shopId,
                        }
                    })
                    .then(res => {
                        // this.dataSource = res.length > 0 ? res[0].list : [];
                        if(res.staticsOtherVos.length > 0) {
                            this.dataSource = res.staticsOtherVos[0].list;
                            this.message = `总核销人数：${res.total}人，其中成人${res.adultNum}人、儿童${res.babyNum}人`;
                        }else {
                            this.dataSource = [];
                            this.message = `总核销人数：0人，其中成人0人、儿童0人`;
                        }
                    });
                });
            },
            // 导出excel
            exportExcel() {
                this.form.validateFields((err, values) => {
                    if (err) return;
                    const startTime = values['startTime'] ? values['startTime'] : []
                    values.startDate = startTime.length > 0 ? startTime[0].format('YYYY-MM-DD') : undefined
                    values.endDate = startTime.length > 0 ? startTime[1].format('YYYY-MM-DD') : undefined
                    this.loading = true;
                    this.$api.statement.ticketVerifyCountExport({
                        body: {
                            ...values,
                            shopId: this.shopId,
                        }
                    }).then(res => {
                        this.openExportModal();
                        this.loading = false;
                    }).catch(err => {
                        this.loading = false;
                    });
                });
            },
            /**
             * @func openExportModal 打开导出记录弹窗
             */
            openExportModal() {
                this.$refs.reportExportModal.open();
            }
        }, 
        beforeCreate() {
            this.form = this.$form.createForm(this);
        },
        created() {},
        mounted() {
            this.getList();
        },
        computed: {
            ...mapGetters(["shopId"])
        },
    };
</script>
<style lang="scss" scoped>
</style>